/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { NewsManagementCreateNewsRequest } from '../models/NewsManagementCreateNewsRequest';
import type { NewsManagementCreateNewsResponseApiRespoonse } from '../models/NewsManagementCreateNewsResponseApiRespoonse';
import type { NewsManagementDeleteNewsRequest } from '../models/NewsManagementDeleteNewsRequest';
import type { NewsManagementDeleteNewsResponseApiRespoonse } from '../models/NewsManagementDeleteNewsResponseApiRespoonse';
import type { NewsManagementEditNewsRequest } from '../models/NewsManagementEditNewsRequest';
import type { NewsManagementEditNewsResponseApiRespoonse } from '../models/NewsManagementEditNewsResponseApiRespoonse';
import type { NewsManagementListNewsRequest } from '../models/NewsManagementListNewsRequest';
import type { NewsManagementListNewsResponseApiRespoonse } from '../models/NewsManagementListNewsResponseApiRespoonse';
import type { NewsManagementPreviewNewsRequest } from '../models/NewsManagementPreviewNewsRequest';
import type { NewsManagementPreviewNewsResponseApiRespoonse } from '../models/NewsManagementPreviewNewsResponseApiRespoonse';
import type { NewsManagementShowNewsRequest } from '../models/NewsManagementShowNewsRequest';
import type { NewsManagementShowNewsResponseApiRespoonse } from '../models/NewsManagementShowNewsResponseApiRespoonse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class NewsManagementNewsService {

    /**
     * 投稿一覧
     * @param requestBody
     * @returns NewsManagementListNewsResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminNews(
        requestBody: NewsManagementListNewsRequest,
    ): CancelablePromise<NewsManagementListNewsResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/news',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * get news
     * @param requestBody
     * @returns NewsManagementShowNewsResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminNewsShow(
        requestBody: NewsManagementShowNewsRequest,
    ): CancelablePromise<NewsManagementShowNewsResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/news/show',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * 投稿の新規登録
     * @param requestBody
     * @returns NewsManagementCreateNewsResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminNewsCreate(
        requestBody: NewsManagementCreateNewsRequest,
    ): CancelablePromise<NewsManagementCreateNewsResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/news/create',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * 投稿の更新
     * @param requestBody
     * @returns NewsManagementEditNewsResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminNewsEdit(
        requestBody: NewsManagementEditNewsRequest,
    ): CancelablePromise<NewsManagementEditNewsResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/news/edit',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * 投稿の削除
     * @param requestBody
     * @returns NewsManagementDeleteNewsResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminNewsDelete(
        requestBody: NewsManagementDeleteNewsRequest,
    ): CancelablePromise<NewsManagementDeleteNewsResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/news/delete',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * 投稿プレビュー
     * @param requestBody
     * @returns NewsManagementPreviewNewsResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminNewsPreview(
        requestBody: NewsManagementPreviewNewsRequest,
    ): CancelablePromise<NewsManagementPreviewNewsResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/news/preview',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

}
